import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {  useParams } from 'react-router-dom';
import { PhoneNumberClient } from '../../api/server';
import { Button, FormLabel, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { ExtendedClient } from '../../api/ExtendedClient';

function PhoneBook() {
    const globalInfo = useSelector((state) => state.globalInfo)
    let { currentPhoneNumberId } = useParams();
    const [name, setName] = useState("");
    const [phoneNumberDigits, setPhoneNumberDigits] = useState("");
    const [phoneBookItems, setPhoneBookItems] = useState([])

    const [addMode, setAddMode] = useState(false)

    function refreshPhoneBook() {
        const client = (new ExtendedClient(PhoneNumberClient)).getClient();
        
        if (currentPhoneNumberId) {

            client.getPhoneBook(currentPhoneNumberId).then((data) => {
                setPhoneBookItems(data);
            })
        }
    }

    function deleteById(id) {
        const client = (new ExtendedClient(PhoneNumberClient)).getClient();

        client.deletePhoneBookItem(currentPhoneNumberId, id).then(() => {
            refreshPhoneBook();
        })

    }
    function cancel(){
        setAddMode(false) ;
            setName("")
            setPhoneNumberDigits("")
    }
    
    function addToPhoneBook() {
        const client = (new ExtendedClient(PhoneNumberClient)).getClient();

        client.addPhoneBookItem(currentPhoneNumberId, name, phoneNumberDigits).then(() => {
            refreshPhoneBook();
            setAddMode(false) ;
            setName("")
            setPhoneNumberDigits("")
        })

    }

    useEffect(() => {
        refreshPhoneBook();

        // eslint-disable-next-line
    }, [currentPhoneNumberId, globalInfo])


    return (

        <div>
            <h1>Phone Book</h1>
            {(!addMode && (phoneBookItems && phoneBookItems.length > 0)) && 
                <Button variant='outlined' onClick={() => { setAddMode(!addMode) }}>Add New
                </Button>}
            
            {
                !(!addMode && (phoneBookItems && phoneBookItems.length) > 0) && <><FormLabel>Name: </FormLabel>

                    <TextField fullWidth={true} value={name} onChange={(e) => { setName(e.target.value) }}></TextField>

                    <FormLabel>10 Digit Phone Number: </FormLabel>
                    <TextField fullWidth={true} value={phoneNumberDigits} onChange={(e) => { setPhoneNumberDigits(e.target.value) }}></TextField>
                    <br></br><br></br>
                    <Button variant='outlined' onClick={() => { addToPhoneBook(); }}>Save</Button> &nbsp;
                    <Button variant='outlined' onClick={() => { cancel() }}>Cancel</Button>
                </>

            }
            <br></br><br></br>
            {
                (!addMode && (phoneBookItems && phoneBookItems.length > 0)) &&
                <>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <strong>Name</strong>
                                    </TableCell>
                                    <TableCell>
                                        <strong>Telephone Number</strong>
                                    </TableCell>

                                    <TableCell>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    phoneBookItems.map((item, index) => {
                                        return <TableRow key={item.id}>
                                            <TableCell>
                                                {item.name}
                                            </TableCell>
                                            <TableCell>
                                                {item.phoneNumberDigits}
                                            </TableCell>
                                            <TableCell>
                                                <Button variant='outlined' onClick={() => { deleteById(item.id) }} >Delete</Button>
                                            </TableCell>
                                        </TableRow>
                                    })
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>

                </>
            }
        </div>
    )
}

export default PhoneBook